import bokeh from '../../../assets/tips/bokeh.webp';
import layers from '../../../assets/tips/layers.webp';
import market from '../../../assets/tips/market.webp';
import optimize from '../../../assets/tips/optimize.webp';
import uiExamples from '../../../assets/tips/ui-examples.webp';
import uiLayers from '../../../assets/tips/ui-layers.webp';
import uiToolbar from '../../../assets/tips/ui-toolbar.webp';
import welcome from '../../../assets/tips/welcome.webp';

/**
 * Tip header artwork. Backgrounds are generated illustrations; the ui* images are crops of the real
 * app (home page, layer list, left toolbar) and go stale when that UI changes — re-capture them then.
 */
export const TIP_IMAGES = { welcome, bokeh, layers, optimize, market, uiExamples, uiLayers, uiToolbar };

/** Warm the browser cache so switching tips doesn't flash an empty header. */
export const preloadTipVisuals = () => {
  Object.values(TIP_IMAGES).forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};
